import { Link } from 'lib/ui/link';

export class VendorLink extends Link {
    constructor(options) {
        const { vendor } = options;

        super({
            url: vendor.url,
            label: vendor.label,
            target: '_blank',
            rel: 'noopener',
        });
    }
}
